import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React, { useContext, useRef } from 'react';
import { useVisuallyHidden } from 'react-aria';
import { DragAndDropContext } from 'react-aria-components';

function RootDropIndicator() {
  var _useContext = useContext(DragAndDropContext),
    dragAndDropHooks = _useContext.dragAndDropHooks,
    dropState = _useContext.dropState;
  var ref = useRef(null);
  var _ref = dragAndDropHooks.useDropIndicator({
      target: {
        type: 'root'
      }
    }, dropState, ref),
    dropIndicatorProps = _ref.dropIndicatorProps;
  var isDropTarget = dropState.isDropTarget({
    type: 'root'
  });
  var _useVisuallyHidden = useVisuallyHidden(),
    visuallyHiddenProps = _useVisuallyHidden.visuallyHiddenProps;
  if (!isDropTarget && dropIndicatorProps['aria-hidden']) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    role: "row",
    className: "absolute",
    "aria-hidden": dropIndicatorProps['aria-hidden']
  }, /*#__PURE__*/React.createElement("div", {
    role: "gridcell"
  }, /*#__PURE__*/React.createElement("div", _extends({
    role: "button"
  }, visuallyHiddenProps, dropIndicatorProps, {
    ref: ref
  }))));
}

export { RootDropIndicator as default };
//# sourceMappingURL=root-drop-indicator.esm.js.map
